const cancelPlanSteps = {
  DISCOUNT: 'discount',
  EXIT_SURVEY: 'exit-survey',
  CONFIRMATION: 'confirmation',
};

export default cancelPlanSteps;
